import { MoveIcon } from 'lucide-react';
import { useRecoilState } from 'recoil';
import SplitToggleButton from '~/components/Buttons/SplitToggleButton';
import { selectedToolState } from '~/state/atoms/toolsAtoms';
import PanToolOptions from './PanToolOptions';

export default function PanningTool() {
    const [tool, setTool] = useRecoilState(selectedToolState);

    return (
        <SplitToggleButton
            isSelected={tool === 'pan'}
            value="pan"
            onToggle={() => setTool('pan')}
            icon={<MoveIcon />}
            tooltipTitle="Pan"
            popperComponent={<PanToolOptions />}
        />
    );
}
